<template>
  <recurring-orders-reports-view
    :userId="getUserIdFromRouteParams()"
    :embedded="true"
  />
</template>

<script>
// Zakładka "Obiady" na karcie użytkownika (SAPP00016). Reużywa raportu obiadów, ale w
// trybie embedded - zawężonym do jednego podopiecznego i bez globalnych narzędzi.
import RecurringOrdersReportsView from "../components/reports/RecurringOrdersReportsView.vue";

export default {
  components: { RecurringOrdersReportsView },
  name: "CustomerObiady",

  methods: {
    getUserIdFromRouteParams() {
      return this.$route.params.id;
    },
  },
};
</script>

<style scoped></style>
